module.exports = __webpack_public_path__ + "static/arrow-north-logo.c505ec0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/img/vendors/arrow-north-logo.png
// module id = 656
// module chunks = 172845445241205